angular.module('pitch.app')

.factory('Nps', function(config, $resource) {
    return $resource(config.apiUri + '/songs/:tempoSongId/nps');
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Nps.js